










import Vue, { PropOptions } from 'vue';

export type Image = Blok & {
  image: BlokFieldAsset;
  width: string;
  height: string;
  aspectRatio: '16/9' | '1/1';
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<Image>,
  },
  computed: {
    cssVars(): CSSVars {
      return {
        '--width': this.blok?.width,
        '--height': this.blok?.height,
        '--aspect-ratio': this.blok?.aspectRatio,
      };
    },
  },
});
